import { $host } from './index';

//  Функция для получения статистических данных.
export const getStatsPageCounters = async () => {
    try
    {
        const token = localStorage.getItem('token');

        const { data } = await $host.post('api/stats/counters', { token });

        if (data?.error)
            throw new Error(data.error);

        return data;
    }catch (error)
    {
        console.error(error);

        return {
            error: error.message
        };
    }
};